<template>
  <div
    class="toolbox-size"
    :class="{ 'active-size': isSizeActive }"
    @click="setCanvasToolSize"
    :style="'background-image:url(' + imagePath(image) + ');'"
  ></div>
</template>

<script>
export default {
  name: 'tr-toolbox-size',
  props: {
    image: {
      type: null,
      default: function () {
        return {};
      },
    },
    size: {
      type: null,
      default: function () {
        return {};
      },
    },
  },
  methods: {
    imagePath(iconId) {
      let images = require.context('../../../../../assets/icons/book/toolbox/', false, /\.png$/);
      return images('./' + iconId + '.png');
    },
    setCanvasToolSize() {
      console.log(' this.size', this.size);
      this.$store.commit('CHANGE_CANVA_STOOL_SIZE', this.size);
    },
  },
  computed: {
    isSizeActive() {
      return this.$store.getters.toolSize === this.size ? true : false;
    },
    boxPaintBrushSize() {
      return this.size;
    },
    toolSize() {
      return this.$store.getters.toolSize;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/sass/variable';
.toolbox-size {
  width: $toolboxBigIcon;
  height: $toolboxBigIcon;
  background-size: contain;
  background-repeat: no-repeat;
  -webkit-font-smoothing: subpixel-antialiased;
  backface-visibility: hidden;
  cursor: pointer;
  &:hover {
    box-shadow: inset 0 0 12px 3px $canvasActive;
  }
}
.toolbox-size.active-size {
  box-shadow: inset 0 0 12px 3px $canvasActive;
}
</style>
